
import { Fragment, useEffect } from "react";

import Bucket from './components/BucketComponents/Bucket/Bucket';
import BucketImagePhoto from "./components/BucketComponents/Bucket/BucketImagePhoto";
import Register from './components/subscription/Register';

import GetSubscriptionData from './components/subscription/GetSubscriptionData';
import ServiceBuckets from './components/BucketComponents/ServiceBuckets/ServiceBuckets';


import { useStore } from "./hook-store/store";
import { 
  getCustomerDataSubscriptions, 
  // getCurrentSubscription, 
  // fetchPrices 
} from './util/stripe';

export default function BucketSubscriptionData(props) {

  const { isAuth } = props;

  const [store, dispatch] = useStore();
  const { isStripeApi } = store.stripeData;
  const { isServiceBucketsApi } = store.serviceBucketsStore;

  let userLoginEmail = '';

  if (typeof window !== 'undefined') {
    userLoginEmail = localStorage.getItem("email")
    ? localStorage.getItem("email")
    : "";
  }

  useEffect(() => {
    if (isServiceBucketsApi && isStripeApi) {
      //@ts-ignore
      dispatch('SET_ISALLAPIS', true);
    } else {
      //@ts-ignore
      dispatch('SET_ISALLAPIS', false);
    }
  }, [isStripeApi, isServiceBucketsApi]);


  useEffect(() => {
    const lsCustomerEmail = localStorage.getItem('customerEmail');
    
    if (userLoginEmail && lsCustomerEmail) {
      const token = localStorage.getItem('token');
    
      getCustomerDataSubscriptions(token, userLoginEmail)
        .then(result => {
          console.log('get sub result', result);

          if (result.data.length > 0) {
            const subs = result.data;
            // dispatch('SET_SUBSCRIPTIONS', subs);

            const remeetSubs = subs.filter(sub => {
              return sub.metadata.service === 'kura-storage';
            })

            //@ts-ignore
            dispatch('SET_SUBSCRIPTIONS', remeetSubs);
          }

        })
        .catch(err => {
          console.log('get sub error', err);
        });
    }
  }, [userLoginEmail]);

  return (
    <Fragment>
      {isAuth && (
        <div>
          <Bucket />
          <BucketImagePhoto />
          <Register />
          <GetSubscriptionData />
          <ServiceBuckets />
        </div>
      )}
    </Fragment>
  )
}